/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_External_Booking_Edit_Payable_AmountInputs */

const en_admin_external_booking_edit_payable_amount = /** @type {(inputs: Admin_External_Booking_Edit_Payable_AmountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Payable amount`)
};

/** @type {(inputs: Admin_External_Booking_Edit_Payable_AmountInputs) => LocalizedString} */
const de_admin_external_booking_edit_payable_amount = en_admin_external_booking_edit_payable_amount;

/** @type {(inputs: Admin_External_Booking_Edit_Payable_AmountInputs) => LocalizedString} */
const es_admin_external_booking_edit_payable_amount = en_admin_external_booking_edit_payable_amount;

/** @type {(inputs: Admin_External_Booking_Edit_Payable_AmountInputs) => LocalizedString} */
const fr_admin_external_booking_edit_payable_amount = en_admin_external_booking_edit_payable_amount;

/** @type {(inputs: Admin_External_Booking_Edit_Payable_AmountInputs) => LocalizedString} */
const it_admin_external_booking_edit_payable_amount = en_admin_external_booking_edit_payable_amount;

/** @type {(inputs: Admin_External_Booking_Edit_Payable_AmountInputs) => LocalizedString} */
const pt_br2_admin_external_booking_edit_payable_amount = en_admin_external_booking_edit_payable_amount;

/** @type {(inputs: Admin_External_Booking_Edit_Payable_AmountInputs) => LocalizedString} */
const pl_admin_external_booking_edit_payable_amount = en_admin_external_booking_edit_payable_amount;

/** @type {(inputs: Admin_External_Booking_Edit_Payable_AmountInputs) => LocalizedString} */
const hu_admin_external_booking_edit_payable_amount = en_admin_external_booking_edit_payable_amount;

/** @type {(inputs: Admin_External_Booking_Edit_Payable_AmountInputs) => LocalizedString} */
const ro_admin_external_booking_edit_payable_amount = en_admin_external_booking_edit_payable_amount;

/**
* | output |
* | --- |
* | "Payable amount" |
*
* @param {Admin_External_Booking_Edit_Payable_AmountInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_external_booking_edit_payable_amount = /** @type {((inputs?: Admin_External_Booking_Edit_Payable_AmountInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_External_Booking_Edit_Payable_AmountInputs, { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_external_booking_edit_payable_amount(inputs)
	if (locale === "de") return de_admin_external_booking_edit_payable_amount(inputs)
	if (locale === "es") return es_admin_external_booking_edit_payable_amount(inputs)
	if (locale === "fr") return fr_admin_external_booking_edit_payable_amount(inputs)
	if (locale === "it") return it_admin_external_booking_edit_payable_amount(inputs)
	if (locale === "pt-BR") return pt_br2_admin_external_booking_edit_payable_amount(inputs)
	if (locale === "pl") return pl_admin_external_booking_edit_payable_amount(inputs)
	if (locale === "hu") return hu_admin_external_booking_edit_payable_amount(inputs)
	return ro_admin_external_booking_edit_payable_amount(inputs)
});
export { admin_external_booking_edit_payable_amount as "admin.external_booking_edit.payable_amount" }